import {Colors, hexToRGB} from '@wandb/common/css/globals.styles';
import styled from 'styled-components';

export const Input = styled.input`
  border: 1px solid ${Colors.GRAY_350};
  border-radius: 4px;
  padding: 8px 12px;
  width: 100%;
  font: inherit;

  &:focus-visible {
    border: 1px solid transparent;
    outline: 2px solid ${hexToRGB(Colors.TEAL_LIGHT, 0.5)};
  }

  &::placeholder {
    color: ${Colors.GRAY_500};
  }
`;
Input.displayName = 'S.Input';
